<div class="wms-custom-map-form">
  <form [formGroup]="wmsFormGroup" class="form-details">
    <div class="form-row">
      <mat-form-field>
        <mat-select
          name="securityType"
          formControlName="securityType"
          [required]="true"
          placeholder="{{ 'sources.details.Security' | translate }}"
        >
          <mat-option *ngFor="let type of securityTypes" [value]="type.value">
            {{ type.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="getControlRequiredError('securityType')">{{ "validation.required" | translate: {
          name: ('company.baseMaps.mapType' | translate)
        } }} </mat-error>
      </mat-form-field>
    </div>

    <div class="get-layers" [ngClass]="{ loading: isLayersDependsFieldsDataLoading }">
      <mat-spinner class="loading-spinner" [diameter]="60" *ngIf="isLayersDependsFieldsDataLoading"></mat-spinner>

      <ng-container *ngIf="isWMSPassword()">
        <div class="form-row">
          <mat-form-field class="sync-element">
            <input
              matInput
              type="text"
              formControlName="Username"
              name="Username"
              [readonly]="isLayersDependsFieldsDataLoading"
              [required]="isWMSPassword()"
              placeholder="{{ 'sources.fields-placeholders.Username' | translate }}"
            />
            <mat-error *ngIf="getControlRequiredError('Username')">{{ "validation.required" | translate: { name: ('sources.fields-placeholders.Username' | translate) } }} </mat-error>
          </mat-form-field>

          <mat-form-field class="sync-element">
            <input
              type="password"
              matInput
              [readonly]="isLayersDependsFieldsDataLoading"
              [required]="isWMSPassword() && !isUpdateMode"
              formControlName="Password"
              name="Password"
              placeholder="{{ 'sources.fields-placeholders.Password' | translate }}"
            />
            <mat-error *ngIf="getControlRequiredError('Password')">{{ "validation.required" | translate: { name: ('sources.fields-placeholders.Password' | translate) } }} </mat-error>
          </mat-form-field>
        </div>
      </ng-container>

      <div class="form-row layers-depends-fields">
        <mat-form-field class="sync-element">
          <mat-select
            [disabled]="isLayersDependsFieldsDataLoading"
            formControlName="Version"
            placeholder="{{ 'customMapFields.Version' | translate }}"
          >
            <mat-option value="1.3.0">1.3.0</mat-option>
            <mat-option value="1.1.1">1.1.1</mat-option>
            <mat-option value="1.1.0">1.1.0</mat-option>
            <mat-option value="1.0.0">1.0.0</mat-option>
          </mat-select>
          <mat-error *ngIf="getControlRequiredError('Version')">
            {{ "validation.required" | translate: { name: ('customMapFields.Version' | translate) } }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field class="sync-element">
          <input
            matInput
            [readonly]="isLayersDependsFieldsDataLoading"
            formControlName="BaseUrl"
            name="BaseUrl"
            placeholder="{{ 'customMapFields.BaseUrl' | translate }}"
            required
          />
          <mat-error *ngIf="getControlRequiredError('BaseUrl')">
            {{ "validation.required" | translate: { name: ('customMapFields.BaseUrl' | translate) } }}
          </mat-error>
        </mat-form-field>
      </div>

      <button
        mat-raised-button
        (click)="getFieldsValue()"
        [ngClass]="{ disabled: isGetLayersButtonDisabled() }"
        [disabled]="isGetLayersButtonDisabled()"
        class="get-layers-btn"
      >
        {{ "components.CustomMaps.GetLayers" | translate | uppercase }}
      </button>

      <div class="get-layers-error" *ngIf="isGetLayersError">
        <mat-icon>report</mat-icon>
        <p class="error-text">{{ errorText }}</p>
      </div>
    </div>

    <ng-container *ngIf="isShowLayersDependsFields">
      <div class="form-row">
        <mat-form-field>
          <input
            formControlName="Layers"
            type="text"
            required
            matInput
            [matAutocomplete]="auto"
            autocomplete="off"
            placeholder="{{ 'customMapFields.Layers' | translate }}"
          />
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
            <mat-option *ngFor="let layer of filteredLayersOptions$ | async" [value]="layer.Name">
              {{ layer.Title }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="getControlRequiredError('Layers')">
            {{ "validation.required" | translate: { name: ('customMapFields.Layers' | translate) } }}
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-select formControlName="ImageFormat" placeholder="{{ 'customMapFields.ImageFormat' | translate }}" required>
            <mat-option *ngFor="let imageFormat of imageFormats" [value]="imageFormat">{{ imageFormat }}</mat-option>
          </mat-select>
          <mat-error *ngIf="getControlRequiredError('ImageFormat')">
            {{ "validation.required" | translate: { name: ('customMapFields.ImageFormat' | translate) } }}
          </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="isShowStylesField()">
          <mat-select formControlName="Styles" placeholder="{{ 'customMapFields.Styles' | translate }}">
            <mat-option *ngFor="let style of styles" [value]="style">{{ style }}</mat-option>
          </mat-select>
          <mat-error *ngIf="getControlRequiredError('Styles')">
            {{ "validation.required" | translate: { name: ('customMapFields.Styles' | translate) } }}
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>
  </form>
</div>
